export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT = "LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";

export const SET_LOADING = "SET_LOADING";
export const SET_LOADED = "SET_LOADED";

export const RESPONSE_LOADED = "RESPONSE_LOADED";
export const RESPONSE_SAVED = "RESPONSE_SAVED";
export const RESPONSE_ARCHIVED = "RESPONSE_ARCHIVED";
export const SECTION_LOADED = "SECTION_LOADED";
export const NOT_FOUND = "NOT_FOUND";